import { Box, Typography } from "@mui/material";
import { colorsFoundation } from "@accredo/fe-shared/theme/index.js";
import PropTypes from "prop-types";

export default function EmptyRowMessage({ children }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        py: 4, // ~2rem
      }}
    >
      <Typography
        component="p"
        sx={{
          margin: 0,
          fontSize: "1rem",
          fontWeight: 400,
          lineHeight: 1.5,
          fontStyle: "italic",
          textAlign: "center",
          color: colorsFoundation.neutral[700],
          maxWidth: "min(100vw, 610px)",
          width: "100%",
        }}
      >
        {children}
      </Typography>
    </Box>
  );
}

EmptyRowMessage.propTypes = {
  children: PropTypes.node,
};
